import React, { useEffect, useState } from "react";
import { List, Modal, Popconfirm, Skeleton } from "antd";
import { useLazyGetAssetAllWorkOrdersQuery } from "../../store/services/api/work-order-api";
import {humanizeEnum} from "../../utils/humanizers";
import { WorkOrderType } from "../../store/data/entities/work-order";
import { WorkOrderStatus } from "../../store/data/entities/work-order";
import { Button } from "antd";
import {useNavigation} from "@react-navigation/native";



interface AssetAllWorkOrdersModalProps {
  assetId: string;
  workOrderReference?: string;
  workOrderStatuses?: WorkOrderStatus[];
  workOrderTypes?: WorkOrderType[];
  triggerContent: React.ReactNode;
}

export default function AssetAllWorkOrdersModal({
  assetId,
  workOrderReference,
  workOrderStatuses,
  workOrderTypes,
  triggerContent,
}: AssetAllWorkOrdersModalProps) {
  const [open, setOpen] = useState(false);
  const [getWorkOrders, { data, isFetching }] =
    useLazyGetAssetAllWorkOrdersQuery();

 const navigation = useNavigation<any>();
  useEffect(() => {
    if (open) {
      getWorkOrders({ assetId , statuses: workOrderStatuses, workOrderReference, types: workOrderTypes, page: 1, pageSize: 5000} );
    }
  }, [open, assetId, workOrderStatuses, workOrderReference, workOrderTypes, getWorkOrders]);

  const navigateToEdit = (id: string) => {
    window.open(`/web/workOrders/recordView?id=${id}`, "_blank");
  };


  return (
    <>
      <span
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        style={{ cursor: "pointer", color: "#1677ff" }}
      >
        {triggerContent}
      </span>

      <Modal
        width={850}
        centered
        title="Work Orders"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
      >
        <Skeleton loading={isFetching} active>
          <div
            style={{
              
              display: "flex",
              fontWeight: 600,
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 16px",
            }}
          >
            <div style={{ flex: 2 , padding : 5}}>Work Order Description</div>
            <div style={{ flex: 2 , padding : 5}}>Work Order Reference</div>
            <div style={{ flex: 2 , padding : 5}}>Type</div>
            <div style={{ flex: 2 , padding : 5}}>Is Follow Up?</div>
            <div style={{ flex: 2 , padding : 5}}>Parent Work Order</div>
            <div style={{ flex: 2 , padding : 5}}>Status</div>
          </div>

          <List
            style={{ maxHeight: "50dvh", overflowY: "auto" }}
            dataSource={data?.list || []}
            renderItem={(item) => (
              <List.Item key={item.id} style={{ padding: "8px 16px" }}>
                <div style={{ flex: 2 , padding : 5}}>{item.description}</div>
                <div style={{ flex: 2 , padding : 5}}>
                  <Popconfirm
                      title="Are you sure you want to view this work order you have not saved your changes?"
                      onConfirm={() => navigateToEdit(item.id)}
                      >
                        <Button
                          type="link"
                        >
                          {item.reference}
                        </Button>
  
                    </Popconfirm>
                  
                </div>
                <div style={{ flex: 2 , padding : 5}}>{humanizeEnum(WorkOrderType[item.type])}</div>
                <div style={{ flex: 2 , padding : 5}}>{item.isFollowUp}</div>
                <div style={{ flex: 2 , padding : 5}}>
                  <Popconfirm
                      title="Are you sure you want to view this work order you have not saved your changes?"
                      onConfirm={() => navigateToEdit(item.parentWorkOrderId)}
                      >
                        <Button
                          type="link"
                        >
                          {item.parentWorkOrderReference}
                        </Button>
                    </Popconfirm>
                  </div>
                <div style={{ flex: 2 , padding : 5}}>{humanizeEnum(WorkOrderStatus[item.status])}</div>
              </List.Item>
            )}
          />
        </Skeleton>
      </Modal>
    </>
  );
}
